<template>
  <div id="footer">
    <b-container class="px-5 w-100" fluid="md">
      <b-row>
        <b-col sm="12" lg="4" class="text-center pt-4">
          <info :content="footerContent.info"/>
        </b-col>
        <b-col sm="12" lg="4" class="text-center pt-4" align-self="center">
          <social-media :content="footerContent.socialMediaLinks"/>
        </b-col>
        <b-col sm="12" lg="4" class="text-center pt-4">
          <links :content="footerContent.links"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center pt-4 pb-4">
          <div class="cs-footer-credits" v-html="noteText()"/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Info from '@/components/footer/Info.vue';
import SocialMedia from '@/components/footer/SocialMedia.vue';
import Links from '@/components/footer/Links.vue';
import { replaceContentPlaceholder } from '@/utils/content';
import { mapGetters } from 'vuex';

export default {
  name: 'Footer',
  components: { Links, SocialMedia, Info },
  created() {
    this.$store.dispatch('content/loadContentForView', 'footer');
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      footerContent: 'content/getFooterContent',
    }),
  },
  methods: {
    noteText() {
      return replaceContentPlaceholder(this.footerContent.developer.text,
        `<b-link href="${this.footerContent.developer.link}" class="cs-footer-credits-link" target="_blank">${this.footerContent.developer.author}</b-link>`);
    },
  },
};
</script>

<style scoped lang="scss">
#footer {
  background-color: $brandSecondaryColor;
}

.cs-footer-credits {
  color: $footerPrimaryColor;
  font-size: 14px;
}

/deep/ .cs-footer-credits-link {
  color: $brandPrimaryColor;
}
</style>
